/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer2_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer" | "ReplyListContainer3_viewer">;
    readonly " $refType": "ReplyListContainer2_viewer";
};
export type ReplyListContainer2_viewer$data = ReplyListContainer2_viewer;
export type ReplyListContainer2_viewer$key = {
    readonly " $data"?: ReplyListContainer2_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer2_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer2_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer3_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '133345f3753af95cd16fb63b49de5865';
export default node;
